import { Skeleton } from "@/shared/ui";

export default function PendingActionsPageSkeleton() {
  return (
    <div className="flex gap-6">
      <div className="flex-1 min-w-0 flex flex-col gap-3">
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="flex items-center gap-4 p-4 radius-lg surface-base-fill">
            <Skeleton height={40} width={40} borderRadius={6} />
            <div className="flex-1 flex flex-col gap-2">
              <Skeleton height={16} width="60%" />
              <div className="flex gap-2">
                <Skeleton height={22} width={80} borderRadius={12} />
                <Skeleton height={22} width={70} borderRadius={12} />
                <Skeleton height={14} width={90} />
              </div>
            </div>
            <Skeleton height={16} width={80} />
          </div>
        ))}
      </div>

      <div className="w-2xs shrink-0 flex flex-col radius-lg surface-base-fill overflow-hidden self-start">
        <div className="px-5 py-4 border-b surface-container-stroke">
          <Skeleton height={18} width={80} />
        </div>
        <div className="px-5 py-4">
          <Skeleton height={36} width="100%" borderRadius={8} />
        </div>
        <div className="px-5 py-4 border-t surface-container-stroke flex flex-col gap-2">
          <Skeleton height={14} width={80} />
          <div className="flex flex-wrap gap-2">
            {Array.from({ length: 6 }).map((_, i) => (
              <Skeleton key={i} height={30} width={70 + i * 5} borderRadius={6} />
            ))}
          </div>
        </div>
        <div className="px-5 py-4 border-t surface-container-stroke flex flex-col gap-2">
          <Skeleton height={14} width={80} />
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} height={20} width={120} />
          ))}
        </div>
        <div className="px-5 py-4 border-t surface-container-stroke flex flex-col gap-2">
          <Skeleton height={14} width={100} />
          <Skeleton height={36} width="100%" borderRadius={8} />
        </div>
      </div>
    </div>
  );
}
